import { Button } from '~/components/button'
import type { ViewProps } from 'react-native'
import * as Comp from './coachmark-header.styles'

type CoachmarkHeaderProps = ViewProps & {
  title: string
  tag?: React.ReactNode
  onClose: () => void
}

export function CoachmarkHeader({
  title,
  tag,
  onClose,
  testID,
  ...viewProps
}: CoachmarkHeaderProps) {
  return (
    <Comp.Header testID={testID} {...viewProps}>
      <Comp.Title numberOfLines={2}>{title}</Comp.Title>
      {tag && <Comp.TagContainer>{tag}</Comp.TagContainer>}
      <Comp.ButtonContainer>
        <Button.Root
          testID="tooltip-close-button"
          onPress={onClose}
          variant="neutral-tertiary"
          size="ml"
        >
          <Button.Icon symbol="rdicon-dismiss" />
        </Button.Root>
      </Comp.ButtonContainer>
    </Comp.Header>
  )
}
